var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Heading } from '../heading';
import { useCard } from './card-context';
const sizeMap = {
    large: 'xlarge',
    medium: 'large',
};
function Header(_a) {
    var { as = 'h3', children } = _a, restProps = __rest(_a, ["as", "children"]);
    const { size } = useCard();
    return (_jsx(Heading, Object.assign({ size: sizeMap[size] }, Object.assign({ as }, restProps), { children: children })));
}
export default Header;
